export const constants = {
  SHOW_NOT_ALLOWED_TO_BUY: 'SHOW_NOT_ALLOWED_TO_BUY',
};
